<template>
    <div>
        <v-toolbar
                dense
                color="primary"
                dark
                extended
                extension-height="300"
                text
        >
            <v-toolbar-title class="mx-auto" slot="extension">
                <!-- <span>ここからセミナー・グルコンに参加、開催できます</span> -->
                <h2>{{appLabels.appTitle}}</h2>
                <!-- <v-layout row>
                    <v-flex wrap>
                        <v-btn outlined large fab color="white" class="outine-2">
                            <i class="fab fa-vuejs fa-3x"></i>
                        </v-btn>
                    </v-flex>
                    <v-flex wrap>
                        <v-btn outlined large fab color="white" class="outine-2">
                            <i class="fab fa-node fa-3x"></i>
                        </v-btn>
                    </v-flex>
                    <v-flex wrap>
                        <v-btn outlined large fab color="white" class="outine-2">
                            <i class="fab fa-laravel fa-2x"></i>
                        </v-btn>
                    </v-flex>
                </v-layout> -->
            </v-toolbar-title>
        </v-toolbar>

        <v-container>
            <v-layout row>
                <v-flex xs12 md8 offset-md2>
                    <v-card text class="card--flex-toolbar" color="transparent">
                        <v-container fluid grid-list-lg>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <h2 class="white--text"></h2>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md6 lg4 v-for="item in links" :key="item.id">
                                    <v-hover>
                                        <v-card 
                                            slot-scope="{ hover }" 
                                            :class="`elevation-${hover ? 12 : 2}`"
                                            :color="item.color"
                                        >
                                            <v-img
                                                    src=""
                                                    aspect-ratio="2.75"
                                                    height="40px"
                                                    :class="item.color"
                                            ></v-img>

                                            <v-card-title class="white--text">
                                                <div>   
                                                    <h4 class="headline mb-0">{{item.title}}</h4>
                                                    <div>
                                                        {{item.description}}
                                                    </div>
                                                </div>
                                            </v-card-title>

                                            <v-card-actions>
                                                <!-- <v-btn text color="primary" class="learn-more-btn">
                                                    Learn more
                                                </v-btn> -->
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" :to="item.link" >開始</v-btn>
                                            </v-card-actions>

                                            <!-- <v-img
                                                    src=""
                                                    aspect-ratio="2.75"
                                                    height="40px"
                                                    :class="item.color"
                                            ></v-img> -->

                                        </v-card>
                                    </v-hover>
                                </v-flex>
                                <v-flex xs12 sm6 md6 lg4>
                                    <v-hover>
                                        <v-card 
                                            slot-scope="{ hover }" 
                                            :class="`elevation-${hover ? 12 : 2}`"
                                            :color="`purple`"
                                        >
                                            <v-img
                                                    src=""
                                                    aspect-ratio="2.75"
                                                    height="40px"
                                                    :class="`purple`"
                                            ></v-img>

                                            <v-card-title class="white--text">
                                                <div>   
                                                    <h4 class="headline mb-0">お問い合わせ</h4>
                                                    <div>
                                                    </div>
                                                </div>
                                            </v-card-title>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSe9GUkGcwaQOwVXBTL6BvF13C6J8hfgfDU1v0predIWDbwW6Q/viewform">開始</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-hover>
                                </v-flex>
                                <v-flex xs12 sm6 md6 lg4>
                                    <v-hover>
                                        <v-card 
                                            slot-scope="{ hover }" 
                                            :class="`elevation-${hover ? 12 : 2}`"
                                            :color="`green`"
                                        >
                                            <v-img
                                                    src=""
                                                    aspect-ratio="2.75"
                                                    height="40px"
                                                    :class="`green`"
                                            ></v-img>

                                            <v-card-title class="white--text">
                                                <div>   
                                                    <h4 class="headline mb-0">マニュアル</h4>
                                                    <div>
                                                    </div>
                                                </div>
                                            </v-card-title>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" target="_blank" href="http://bit.ly/3tMhd2o">開始</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-hover>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {

        computed: {
            ...mapGetters("config", ["appLabels"]),
        },
        data() {
            return {
                links: [
                    {
                        id: '1',
                        title: '',
                        description: 'セミナー・グルコン',
                        color: 'orange',
                        link: 'seminar/calendar'
                    },
                    // {
                    //     id: '2',
                    //     title: '',
                    //     description: '開催・参加データ',
                    //     color: 'pink',
                    //     link: 'chart'
                    // },
                    // {
                    //     id: '2',
                    //     title: 'セミナーを開催する',
                    //     description: '',
                    //     color: 'teal',
                    //     link: 'host/seminar'
                    // },
                    // {
                    //     id: '3',
                    //     title: '参加予定のセミナー',
                    //     description: '',
                    //     color: 'blue',
                    //     link: 'attend/seminar'
                    // },
                    // {
                    //     id: '4',
                    //     title: 'お問い合わせ',
                    //     description: '',
                    //     color: 'purple',
                    //     link: ''
                    // }
                ]
            }
        },

        methods:{
        },


    }
</script>

<style scoped>
    .outine-2 {
        border: 2px solid white;
    }

    .card--flex-toolbar {
        margin-top: -124px;
    }

    .learn-more-btn {
        text-transform: initial;
        text-decoration: underline;
    }
</style>
